import * as Actions from '../actions/types';

const initialState = {
  loading: false,
};

export const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_HOME_LOADER:
      return {
        ...state,
        loading: action.payload,
      };
    case Actions.CLEAR_HOME_DATA:
      return initialState;
    default:
      return state;
  }
};
